import { OnInit, Component, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ExcelService } from '../excel.service';
import { IMyDateModel } from 'angular-mydatepicker';
import { SecurityService } from 'app/shared/services/security.service';
import { RelocationService } from '../relocation.service';
import { IDtoFilter } from 'app/shared/models/filter.model';
import { IDtoRelocation } from 'app/shared/models/request/relocation/dto-relocation.model';
import { AppConfig } from 'app/app.config';
@Component({
    selector: 'app-relocation-records',
    styleUrls: ['relocation-records.style.scss'],
    templateUrl: 'relocation-records.template.html'
})
export class RelocationRecordsComponent implements OnInit {
    /**Formularios */
    private locale: string = 'es';
    private filters = {} as IDtoFilter;
    /**Notificaciones */
    private listRelocations: IDtoRelocation[]
    private listRelocationsTemp: IDtoRelocation[]
    private search: string;
    private start: IMyDateModel;
    private end: IMyDateModel;
    private showRoles: any;
    private employeeIniId: number;
    private profile: string;
    @ViewChild(DatatableComponent, { static: false }) tableRelocations: DatatableComponent;
    constructor(private spinner: NgxSpinnerService
        , private relocationService: RelocationService
        , private excelService: ExcelService
        , private securityService: SecurityService
        , private configGeneral: AppConfig) {
            this.showRoles = this.securityService.getUserRolesStorage();
            if (this.showRoles !== '') {
                this.employeeIniId = this.showRoles.employeeId;
            }
    }
    ngOnInit(): void {
        this.profile = this.securityService.getProfileStorage('RelocationRecords');
    }

    private getWorkLeavebyFilters(): void {
        this.spinner.show();
        this.filters.startDate = this.getDate(this.start);
        this.filters.endDate = this.getDate(this.end);
        this.filters.employeeId = this.employeeIniId;
        this.filters.profile = this.profile;
        this.relocationService.getRelocations(this.filters).subscribe((res) => {
            if (res.isCorrect) {
                this.listRelocations = res.data as IDtoRelocation[];
                this.listRelocationsTemp = res.data as IDtoRelocation[];
            } else {
                this.configGeneral.newToast('Datos', res.message, 'error');
            }
            this.spinner.hide();
        });
    }
    generateExcel() {
        if (this.listRelocationsTemp != undefined) {
            this.excelService.generateExcelRelocations(this.listRelocations);
        }
    }
    private getDate(event?: IMyDateModel) {
        if(event === undefined) {
            return null;
        }
        return event.singleDate.jsDate;
    }
    private updateFilter() {
        if (this.search === undefined) {
            return;
        }

        const val = this.search.toLowerCase();
        const temp = this.listRelocationsTemp.filter((x: any) => x.employeeName.toLowerCase().startsWith(val)
            || x.reasonName.toLowerCase().startsWith(val)
            || x.trademark.toLowerCase().startsWith(val)
            || x.position.toLowerCase().startsWith(val)
            || x.employeeNum.startsWith(val));
        this.listRelocations = temp;
        this.tableRelocations.offset = 0;
    }
}
